import { useLastSequenceExport } from '../contexts/SequenceExportContext';
import { useAssetDetailsForExportFragment } from '../gql/fragments/generated/AssetDetailsForExport';
import { useGetAssetIdForSequenceExport } from './useGetAssetIdForSequenceExport';

export const useLastExportAssetData = () => {
  const lastSequenceExport = useLastSequenceExport();
  const assetId = useGetAssetIdForSequenceExport(lastSequenceExport);

  const { data: assetData } = useAssetDetailsForExportFragment({
    from: {
      __typename: 'Asset',
      id: assetId,
    },
  });

  return Object.keys(assetData).length > 0 ? assetData : null;
};
